"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _consts = require("../consts");

var _IntervalFrequencyError = _interopRequireDefault(require("../errors/IntervalFrequencyError"));

var _AsNeededFrequency = _interopRequireDefault(require("./Frequencies/AsNeededFrequency"));

var _DayFrequency = _interopRequireDefault(require("./Frequencies/DayFrequency"));

var _HourFrequency = _interopRequireDefault(require("./Frequencies/HourFrequency"));

var _MonthFrequency = _interopRequireDefault(require("./Frequencies/MonthFrequency"));

var _NeverFrequency = _interopRequireDefault(require("./Frequencies/NeverFrequency"));

var _WeekFrequency = _interopRequireDefault(require("./Frequencies/WeekFrequency"));

var _YearFrequency = _interopRequireDefault(require("./Frequencies/YearFrequency"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var DefaultCustomFrequency = {
  numberOfEvents: 1,
  every: 1,
  repeatOn: []
};

var IntervalFrequencyFactory = /*#__PURE__*/function () {
  function IntervalFrequencyFactory() {
    _classCallCheck(this, IntervalFrequencyFactory);
  }

  _createClass(IntervalFrequencyFactory, null, [{
    key: "For",
    value: function For() {
      var frequency = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _consts.IntervalFrequencyEnum.NEVER;
      var customFrequency = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      switch (frequency) {
        case null:
        case _consts.IntervalFrequencyEnum.NEVER:
          return new _NeverFrequency["default"](_consts.IntervalFrequencyEnum.NEVER, _objectSpread(_objectSpread({}, DefaultCustomFrequency), {}, {
            numberOfEvents: 0,
            nonCustomFrequency: _consts.IntervalFrequencyEnum.NEVER
          }));

        case _consts.IntervalFrequencyEnum.AS_NEEDED:
          return new _AsNeededFrequency["default"](_consts.IntervalFrequencyEnum.AS_NEEDED, _objectSpread(_objectSpread({}, DefaultCustomFrequency), {}, {
            nonCustomFrequency: frequency
          }));

        case _consts.IntervalFrequencyEnum.HOUR:
          return new _HourFrequency["default"](_consts.IntervalFrequencyEnum.HOUR, _objectSpread(_objectSpread({}, DefaultCustomFrequency), {}, {
            nonCustomFrequency: frequency
          }));

        default:
          break;
      }

      if (customFrequency) {
        var custom = this.getCustomFrequencyDefaults(frequency, customFrequency);
        var isCustom = !custom.nonCustomFrequency;

        switch (frequency) {
          case _consts.IntervalFrequencyEnum.DAY:
            return new _DayFrequency["default"](frequency, custom, isCustom);

          case _consts.IntervalFrequencyEnum.WEEK:
            return new _WeekFrequency["default"](frequency, custom, isCustom);

          case _consts.IntervalFrequencyEnum.MONTH:
            return new _MonthFrequency["default"](frequency, custom, isCustom);

          case _consts.IntervalFrequencyEnum.YEAR:
            return new _YearFrequency["default"](frequency, custom, isCustom);

          default:
            throw new _IntervalFrequencyError["default"]("custom frequency not supported: ".concat(frequency));
        }
      }

      switch (frequency) {
        case _consts.IntervalFrequencyEnum.DAY:
          return new _DayFrequency["default"](_consts.IntervalFrequencyEnum.DAY, _objectSpread(_objectSpread({}, DefaultCustomFrequency), {}, {
            nonCustomFrequency: frequency
          }));

        case _consts.IntervalFrequencyEnum.WEEK:
          return new _WeekFrequency["default"](_consts.IntervalFrequencyEnum.WEEK, _objectSpread(_objectSpread({}, DefaultCustomFrequency), {}, {
            nonCustomFrequency: frequency
          }));

        case _consts.IntervalFrequencyEnum.TWICE_WEEK:
          return new _WeekFrequency["default"](_consts.IntervalFrequencyEnum.WEEK, _objectSpread(_objectSpread({}, DefaultCustomFrequency), {}, {
            numberOfEvents: 2,
            nonCustomFrequency: frequency
          }));

        case _consts.IntervalFrequencyEnum.MONTH:
          return new _MonthFrequency["default"](_consts.IntervalFrequencyEnum.MONTH, _objectSpread(_objectSpread({}, DefaultCustomFrequency), {}, {
            nonCustomFrequency: frequency
          }));

        case _consts.IntervalFrequencyEnum.TWICE_MONTH:
          return new _MonthFrequency["default"](_consts.IntervalFrequencyEnum.MONTH, _objectSpread(_objectSpread({}, DefaultCustomFrequency), {}, {
            numberOfEvents: 2,
            nonCustomFrequency: frequency
          }));

        case _consts.IntervalFrequencyEnum.QUARTER:
          return new _MonthFrequency["default"](_consts.IntervalFrequencyEnum.MONTH, _objectSpread(_objectSpread({}, DefaultCustomFrequency), {}, {
            every: 3,
            nonCustomFrequency: frequency
          }));

        case _consts.IntervalFrequencyEnum.BIANNUAL:
          return new _MonthFrequency["default"](_consts.IntervalFrequencyEnum.MONTH, _objectSpread(_objectSpread({}, DefaultCustomFrequency), {}, {
            every: 6,
            nonCustomFrequency: frequency
          }));

        case _consts.IntervalFrequencyEnum.TWICE_BIANNUAL:
          return new _MonthFrequency["default"](_consts.IntervalFrequencyEnum.MONTH, _objectSpread(_objectSpread({}, DefaultCustomFrequency), {}, {
            numberOfEvents: 2,
            every: 6,
            nonCustomFrequency: frequency
          }));

        case _consts.IntervalFrequencyEnum.YEAR:
          return new _YearFrequency["default"](_consts.IntervalFrequencyEnum.YEAR, _objectSpread(_objectSpread({}, DefaultCustomFrequency), {}, {
            nonCustomFrequency: frequency
          }));

        default:
          throw new _IntervalFrequencyError["default"]("frequency not supported: ".concat(frequency));
      }
    }
  }, {
    key: "getCustomFrequencyDefaults",
    value: function getCustomFrequencyDefaults(frequency, customFrequency) {
      var custom = _objectSpread(_objectSpread({}, DefaultCustomFrequency), customFrequency);

      if (!(custom.numberOfEvents >= 1)) {
        custom.numberOfEvents = 1;
      }

      if (!(custom.every >= 1)) {
        custom.every = 1;
      }

      if (custom.startMonth != null && (custom.startMonth < 0 || custom.startMonth > 11)) {
        custom.startMonth = null;
      }

      if (custom.startDay != null) {
        if (frequency === _consts.IntervalFrequencyEnum.WEEK) {
          if (custom.startDay < 0 || custom.startDay > 6) {
            custom.startDay = null;
          }
        } else if (custom.startDay < 1 || custom.startDay > 31) {
          custom.startDay = null;
        }
      }

      if (!custom.repeatOn || !Array.isArray(custom.repeatOn)) {
        custom.repeatOn = [];
      }

      return custom;
    }
  }]);

  return IntervalFrequencyFactory;
}();

exports["default"] = IntervalFrequencyFactory;